<div class="containerCharts">
    <div class="search-container">
        <dx-text-box
                placeholder="Search template..."
                valueChangeEvent="keyup"
                valueChangeTimeout="200"
                (onValueChanged)="filterCharts($event)">
        </dx-text-box>
    </div>
    <dx-drawer class="chartsContentContainer" [opened]="true" openedStateMode="shrink" position="left" revealMode="slide" [template]="'panel'">
        <div *dxTemplate="let data of 'panel'" style="width: 240px; height: 100%; overflow: auto;">
            <dx-tile-view
                [items]="chartTemplates"
                [baseItemHeight]="220"
                [baseItemWidth]="220"
                [itemMargin]="10"
                direction="vertical"
                (onItemClick)="selectChartTemplate($event.itemData)">
                <div *dxTemplate="let template of 'item'">
                    <div class="chartTile tiny-border" style="position: relative;">
                        <chart-preview [height]="180" [width]="210"
                                       [chartProject]="template.jsonString"></chart-preview>
                        <div class="tile-content tile-name">{{ template.name }}</div>
                    </div>
                </div>
            </dx-tile-view>
        </div>
        <div class="dx-drawer-content">
            <div class="drawer-content">
                <div class="chart-editor-toolbar">
                    @if(selectedTemplate) {
                        <div class="template-details-panel">
                            <div class="panel-header" (click)="detailsPanelExpanded = !detailsPanelExpanded">
                                <span>{{selectedTemplate?.name}} Details</span>
                                <span class="expand-icon">{{ detailsPanelExpanded ? '^' : 'v' }}</span>
                            </div>
                            @if(detailsPanelExpanded) {
                                <div class="panel-content">
                                    <dx-text-box
                                            class="name-input"
                                            placeholder="Name"
                                            label="Name *"
                                            labelMode="static"
                                            [value]="selectedTemplate?.name"
                                            [isValid]="selectedTemplate?.name?.length > 0"
                                            (valueChange)="selectedTemplate && (selectedTemplate.name = $event)">
                                    </dx-text-box>
                                    <dx-text-box
                                            class="name-input"
                                            placeholder="Description"
                                            label="Description"
                                            labelMode="static"
                                            [value]="selectedTemplate?.description"
                                            (valueChange)="selectedTemplate && (selectedTemplate.description = $event)">
                                    </dx-text-box>
                                    <dx-tag-box
                                            class="name-input"
                                            label="Report Type *"
                                            labelMode="static"
                                            [dataSource]="reportTypesList"
                                            [value]="selectedTemplate?.reportType"
                                            [hideSelectedItems]="true"
                                            [isValid]="selectedTemplate?.reportType?.length > 0"
                                            (onValueChanged)="onReportTypeChange($event)">
                                    </dx-tag-box>
                                    <dx-tag-box
                                            class="name-input"
                                            label="Tenant *"
                                            labelMode="static"
                                            [dataSource]="tenants"
                                            displayExpr="displayName"
                                            valueExpr="value"
                                            [value]="selectedTemplate?.tenant || []"
                                            [hideSelectedItems]="true"
                                            [isValid]="selectedTemplate?.tenant?.length > 0"
                                            (onValueChanged)="onTenantChange($event)">
                                    </dx-tag-box>
                                </div>
                            }
                        </div>
                    }
                    <dx-button icon="save"
                        type="default" stylingMode="contained" hint="Save"
                        class="save-template-button pull-right"
                        [disabled]="!selectedTemplate?.name || !selectedTemplate?.reportType?.length || !selectedTemplate?.tenant?.length || !selectedTemplate?.name?.length"
                        (onClick)="saveChart(selectedTemplate)">
                    </dx-button>
                    <dx-button icon="trash" type="danger" stylingMode="contained" hint="Delete"
                                class="save-template-button pull-right"
                                (onClick)="deleteChart(selectedTemplate)">
                    </dx-button>
                    <dx-button icon="refresh" type="normal" stylingMode="contained" hint="Refresh Sample Data"
                                class="save-template-button pull-right"
                                (onClick)="refreshSampleData()">
                    </dx-button>
                    <dx-button icon="copy" type="normal" stylingMode="contained" hint="Copy template"
                               class="save-template-button pull-right"
                               [disabled]="!selectedTemplate?.id || processing"
                               (onClick)="copyTemplate(selectedTemplate?.id)">
                    </dx-button>
                </div>
                <div #editorDiv class="chart-editor" [style.visibility]="selectedTemplate ? 'visible' : 'hidden'"></div>
            </div>
        </div>
    </dx-drawer>

    <div class="chartsFooter">
        <div class="right-buttons">
            <input aria-hidden="true" type="file" accept=".json" class="file-upload" (change)="importTemplate($event)"
                   hidden #fileInput>
            <dx-button type="default" icon="upload" stylingMode="contained"
                    class="save-template-button margin-right-10"
                    hint="Import"
                    (click)="fileInput.click()">
            </dx-button>
            <dx-button icon="add" type="default" hint="Add" (click)="addChart()">
            </dx-button>
        </div>
    </div>

</div>

<!-- ================= REMOVE CHART TEMPLATE POPUP ================= -->
@if(templateToRemove){
    <dx-popup
            [title]="'Remove Chart Template'"
            [visible]="true"
            [height]="200"
            [width]="500"
            (visibleChange)="templateToRemove=null">

        <div *dxTemplate="let data of 'content'" class="column">
            <div>
                Are you sure you want to remove the chart template
                <b>{{templateToRemove.name}}</b>?
            </div>
        </div>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button (onClick)="templateToRemove = null">Cancel</dx-button>
            </div>
        </dxi-popup-toolbar-item>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button
                        type="danger"
                        (onClick)="confirmDelete()">
                    Remove
                </dx-button>
            </div>
        </dxi-popup-toolbar-item>
    </dx-popup>
}
